import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ConfirmationModal from "views/components/ConfirmationModal";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import PacketDamageCreate from "./PacketDamageCreate";
import ToastModal from "views/components/ToastModal";
import { packetSizes } from "assets/properties/properties";

const PacketDamage = (props) => {
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([
    { id: "branchCode", label: "Branch" },
    { id: "date", label: "Date" },
    { id: "serialNo", label: "Serial No" },
    { id: "size", label: "Size" },
    { id: "weight", label: "Packet Weight"},
    { id: "reason", label: "Reason" },
    { id: "remarks", label: "Remarks" },
    {id: "action", label: "Actions" }
  ]);
  const { classes, featureFlagState } = props;
  const [rawData, setRawData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteDamagePacket, setDeletePacketDamage] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [damagePacketShow, setDamagePacketShow] = useState(true)

  useEffect(() => {
    GetData();
  }, []);

  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PACKET_DAMAGE_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };
  const packetSizeList = typeof featureFlagState?.packetSizesList !== "undefined" ? JSON.parse(featureFlagState?.packetSizesList) : packetSizes;

  // parseIndicatedData function
  const parseIndicatorData = (data) => {
    let reportData = [];
    data.forEach((packet, i) => {
      let row = {
        branchCode: packet.branchCode,
        date: packet.date,
        serialNo:`${packet?.prefix ? packet?.prefix : ''}${packet.serialNo}`,
        size: packetSizeList?.[0]?.name || packet.size,
        weight: packet.packetWeight,
        reason: packet.reason,
        remarks: packet.remarks,
        action: getIcons(packet.id),
      };
      reportData.push(row);
    });
    setSelectedTableData(reportData);
  };
  // icons function calling
  const getIcons = (code) => {
    return (
      <>
        <IconButton
          aria-label="Edit_Packet"
          onClick={() => onClickUpdateData(code)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete_Packet"
          onClick={() => onClickDeleteData(code)}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  const onClickUpdateData = (code) => {
    setDeletePacketDamage(code);
    setDamagePacketShow(false);
  };

  // delete function
  const onClickDeleteData = (code) => {
    setConfirmationModalHeader("Packet Damage");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeletePacketDamage(code);
    setConfirmationModal(true);
  };

  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeletePacketDamage("");
  };

  const handlePositiveResponse = async () => {
    handleNegativeResponse();
    // Call API to delete Branch
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.PACKET_DAMAGE_DELETE + deleteDamagePacket,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Packet Allocation deleted successful", true);
      GetData();
    }
  };

  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
  };

  const onCloseModal = (type) => {
    if (type === "create") {
      toastUpdate("Success", "Packet Damage created successfully", true);
    } else {
      toastUpdate("Success","Packet Damage updated successfully", true);
    }
    GetData();
  };

  const handleDamagePacket = async () => {
    setDamagePacketShow(false);
  };
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      return (
        row?.size?.toLowerCase()?.includes(val?.toLowerCase()) ||
        row?.branchCode?.toLowerCase()?.includes(val?.toLowerCase()) ||
        row?.reason?.toLowerCase()?.includes(val?.toLowerCase()) ||
        row?.remarks?.toLowerCase()?.includes(val?.toLowerCase()) ||
        row?.serialNo?.toString()?.includes(val) 
      );
    });
    parseIndicatorData(filteredData);
  };
  return (
    <GridContainer>
      {damagePacketShow ? (
        <>
          <GridItem xs={12} sm={12} md={12}>
            <SubHeader label="Damage Packet"  button1="Create"
              button1click={handleDamagePacket} 
              onSearchChange={onSearchChange}
              searchLabel="Search For Damaged Packet"
              search
              />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <ColumnGroupingTable
              columns={tableColumns}
              rows={selectedTableData}
            />
          </GridItem>
        </>
      ) : (
        <PacketDamageCreate
          packetAllocationShow={setDamagePacketShow}
          packetId={deleteDamagePacket}
          setPacketId={setDeletePacketDamage}
          classes={classes}
          closeModal={onCloseModal}
          rawData={rawData}
        />
      )}
    {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
  );
};

PacketDamage.propTypes = {
  classes: PropTypes.object,
};

export default PacketDamage;
